// src/pages/IssueReporting/data/mockData.js

// Status color mapping
export const statusColors = {
    OPEN: {
        bg: '#FEF3C7',
        color: '#D97706',
        icon: 'AlertTriangle',
        backgroundColor: '#FEF3C7'
    },
    'IN PROGRESS': {
        bg: '#DBEAFE',
        color: '#3B82F6',
        icon: 'Clock',
        backgroundColor: '#DBEAFE'
    },
    SCHEDULED: {
        bg: '#DBEAFE',
        color: '#3B82F6',
        icon: 'Clock',
        backgroundColor: '#DBEAFE'
    },
    RESOLVED: {
        bg: '#D1FAE5',
        color: '#10B981',
        icon: 'CheckCircle',
        backgroundColor: '#D1FAE5'
    },
    CLOSED: {
        bg: '#F3F4F6',
        color: '#6B7280',
        icon: 'XCircle',
        backgroundColor: '#F3F4F6'
    }
};

// Fallback values for when status isn't found
export const defaultStatus = {
    bg: '#F3F4F6',
    color: '#6B7280',
    icon: 'AlertTriangle',
    backgroundColor: '#F3F4F6'
};

// Priority color mapping
export const priorityColors = {
    High: {bg: '#FEE2E2', color: '#EF4444'},
    Medium: {bg: '#FEF3C7', color: '#F59E0B'},
    Low: {bg: '#D1FAE5', color: '#10B981'}
};

// Default priority for fallback
export const defaultPriority = {bg: '#F3F4F6', color: '#6B7280'};

// Mock data as fallback if API fails
export const mockTickets = [
    {
        id: "TKT-001",
        title: "Water Leakage in Bathroom",
        description: "There's a water leak from the ceiling in the bathroom. It's causing damage to the floor.",
        category: "Plumbing",
        priority: "High",
        status: "Open",
        createdAt: "2025-05-01T09:30:00Z",
        updatedAt: "2025-05-01T15:45:00Z",
        comments: [
            {
                id: "CMT-001",
                text: "We'll send a plumber tomorrow morning between 9-11am.",
                author: "Admin",
                timestamp: "2025-05-01T15:45:00Z"
            }
        ],
        attachments: []
    },
    {
        id: "TKT-002",
        title: "Air Conditioning Not Working",
        description: "The AC unit in the living room isn't cooling properly. It makes a strange noise when turned on.",
        category: "HVAC",
        priority: "Medium",
        status: "In Progress",
        createdAt: "2025-05-03T14:20:00Z",
        updatedAt: "2025-05-04T10:15:00Z",
        comments: [
            {
                id: "CMT-002",
                text: "Technician has been assigned. They'll contact you to schedule a visit.",
                author: "Admin",
                timestamp: "2025-05-04T10:15:00Z"
            }
        ],
        attachments: []
    },
    {
        id: "TKT-003",
        title: "Lost Apartment Key",
        description: "I lost my apartment key and need a replacement as soon as possible.",
        category: "Security",
        priority: "High",
        status: "Resolved",
        createdAt: "2025-05-02T11:00:00Z",
        updatedAt: "2025-05-02T16:30:00Z",
        comments: [
            {
                id: "CMT-003",
                text: "You can pick up a new key from the management office. Please bring ID.",
                author: "Admin",
                timestamp: "2025-05-02T12:45:00Z"
            },
            {
                id: "CMT-004",
                text: "Thank you, I've collected the new key.",
                author: "Tenant",
                timestamp: "2025-05-02T16:30:00Z"
            }
        ],
        attachments: []
    },
    {
        id: "TKT-004",
        title: "Noisy Neighbors",
        description: "The neighbors in unit 304 are playing loud music late at night. This has been ongoing for a week.",
        category: "Noise Complaint",
        priority: "Medium",
        status: "Open",
        createdAt: "2025-05-04T23:15:00Z",
        updatedAt: "2025-05-04T23:15:00Z",
        comments: [],
        attachments: []
    },
    {
        id: "TKT-005",
        title: "Broken Kitchen Sink",
        description: "The kitchen sink is clogged and water doesn't drain properly.",
        category: "Plumbing",
        priority: "Medium",
        status: "Closed",
        createdAt: "2025-04-28T08:45:00Z",
        updatedAt: "2025-04-29T14:20:00Z",
        comments: [
            {
                id: "CMT-005",
                text: "Plumber visited and fixed the issue. Please let us know if you face any more problems.",
                author: "Admin",
                timestamp: "2025-04-29T14:20:00Z"
            }
        ],
        attachments: []
    }
];